import { AI_ASSISTANT_CONVERSATIONS_SCREEN, GREETING_VARIATIONS } from './constants';

export function parseConversationId(screen: string) {
  if (!screen.startsWith(`${AI_ASSISTANT_CONVERSATIONS_SCREEN}/`)) return null;

  const rawId = screen.split('/')[1];

  return parseInt(rawId);
}

export function getGreetingVariation(name: string) {
  const randomIndex = Math.floor(Math.random() * GREETING_VARIATIONS.length);
  return GREETING_VARIATIONS[randomIndex].replace('{{name}}', name);
}

export function shouldAnimateIn(created_at: string) {
  return Date.now() - new Date(created_at).getTime() < 2_000;
}
